import { render, staticRenderFns } from "./ReCaptchaWithFallback.vue?vue&type=template&id=efde5560&scoped=true&"
import script from "./ReCaptchaWithFallback.vue?vue&type=script&lang=js&"
export * from "./ReCaptchaWithFallback.vue?vue&type=script&lang=js&"
import style0 from "./ReCaptchaWithFallback.vue?vue&type=style&index=0&id=efde5560&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efde5560",
  null
  
)

export default component.exports